import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/logo/logo-white.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__main" }
const _hoisted_3 = { class: "footer__contact" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "footer__logo",
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "footer__link-icon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "footer__copyright" }, " Copyright ® 2022 MyDr Sp. z o.o. ul. Puławska 465, 02-844 Warszawa ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FooterNav = _resolveComponent("FooterNav")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleFooterItems, (item, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: index,
            href: item.link,
            class: "footer__link"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: _normalizeClass(`lsi lsi-${item.icon}`)
              }, null, 2)
            ]),
            _createTextVNode(" " + _toDisplayString(item.text), 1)
          ], 8, _hoisted_5))
        }), 128))
      ]),
      _createVNode(_component_FooterNav, { class: "footer__nav" })
    ]),
    _hoisted_7
  ]))
}